export const getCookie = (key: string) => {
    const re = new RegExp(`.*${key}=([^;]+).*`);
    if (re.test(document.cookie)) {
        return decodeURIComponent(document.cookie.replace(re, '$1'));
    }
    return null;
}

export const setCookie = (key, value, options) => {
    options = options || {};
    document.cookie = [
        encodeURIComponent(key),
        '=',
        encodeURIComponent(value),
        options.expires ? `; expires=${options.expires.toUTCString()}` : '',
        options.path ? `; path=${options.path}` : '',
        options.domain ? `; domain=${options.domain}` : '',
    ].join('');
}

/**
 * 获取 csrf 请求，用于 post 方式调用 bff-portal 接口，放到 header 中
 */
export const getCsrfCookie = () => getCookie('_csrf_token');

/**
 * 登录用户名，来自 cookie，可以初步判断是否需要登录
 */
export const getLoginName = () => getCookie('__venus_login_name__');
